import React from 'react';
import { FadeLayer } from './../../styled';
import { Image, VideoWrapper } from './styled';
import assset from './step-5-placeholder.png';

const wrapperStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%'
};

class Step5 extends React.Component {
  render() {
    if (this.props.currentStep !== 5) {
      return null;
    }
    return (
      <div style={wrapperStyle}>
        <FadeLayer />
        <VideoWrapper>
          {this.props.navigated ? (
            <img src="https://cdn.auth0.com/website/homepage/05-result.svg" alt="Result" />
          ) : (
            <video
              muted={'true'}
              autoPlay="true"
              src="https://videos.ctfassets.net/2ntc334xpx65/1irwTRQwWoCiMYswWweyqs/1b342e82f03faf3724edfaeb45293dbc/05_Result.mp4"
            />
          )}
        </VideoWrapper>
      </div>
    );
  }
}

export default Step5;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step5/Step5.js